import { BasisPoints } from '@klear/basis-points'
import type { KlearDate } from '@klear/date'
import type { Money } from '@klear/money'
import type { OrderEventLifecycleState } from '@klear/order-event-lifecycle/lifecycle'

export type PaasOfferMeta = {
  annualizedRateBps: number
  pricingFunderId: number
  pricedToInvoiceId: number
}

export type PaasOfferJson = {
  id: number
  idDisplay: string
  orderId: number
  operationalId: number
  status: OrderEventLifecycleState
  amount: Money
  effectiveDate: KlearDate
  endDate: KlearDate
  annualizedRateBps: number
  pricingFunderId: number
  pricedToInvoiceId: number
  orderIdDisplay?: string
  traderId?: number
  traderName?: string
  traderOrganizationId?: number
  customerId?: number
  customerName?: string
  customerOrganizationId?: number
  pricedToInvoiceIdDisplay?: string
  fundingSpvLabel?: string
  feeId?: number
  fee?: Money
  spvFee?: Money
  fundedEffectiveDate?: KlearDate
  completedEffectiveDate?: KlearDate
}

export class PaasOffer {
  static readonly __klearClass = 'PaasOffer'

  id: number
  idDisplay: string
  readonly orderId: number
  readonly operationalId: number
  status: OrderEventLifecycleState
  amount: Money
  effectiveDate: KlearDate
  endDate: KlearDate
  annualizedRate: BasisPoints
  pricingFunderId: number
  pricedToInvoiceId: number
  orderIdDisplay?: string
  traderId?: number
  traderName?: string
  traderOrganizationId?: number
  customerId?: number
  customerName?: string
  customerOrganizationId?: number
  pricedToInvoiceIdDisplay?: string
  fundingSpvLabel?: string
  feeId?: number
  fee?: Money
  spvFee?: Money
  fundedEffectiveDate?: KlearDate
  completedEffectiveDate?: KlearDate

  constructor(props: PaasOfferJson) {
    this.id = props.id
    this.idDisplay = props.idDisplay
    this.orderId = props.orderId
    this.operationalId = props.operationalId
    this.status = props.status
    this.amount = props.amount
    this.effectiveDate = props.effectiveDate
    this.endDate = props.endDate
    this.annualizedRate = new BasisPoints(props.annualizedRateBps)
    this.pricingFunderId = props.pricingFunderId
    this.pricedToInvoiceId = props.pricedToInvoiceId
    this.orderIdDisplay = props.orderIdDisplay
    this.traderId = props.traderId
    this.traderName = props.traderName
    this.traderOrganizationId = props.traderOrganizationId
    this.customerId = props.customerId
    this.customerName = props.customerName
    this.customerOrganizationId = props.customerOrganizationId
    this.pricedToInvoiceIdDisplay = props.pricedToInvoiceIdDisplay
    this.fundingSpvLabel = props.fundingSpvLabel
    this.feeId = props.feeId
    this.fee = props.fee
    this.spvFee = props.spvFee
    this.fundedEffectiveDate = props.fundedEffectiveDate
    this.completedEffectiveDate = props.completedEffectiveDate
  }

  get pricingMeta(): PaasOfferMeta {
    return {
      annualizedRateBps: this.annualizedRate.value,
      pricingFunderId: this.pricingFunderId,
      pricedToInvoiceId: this.pricedToInvoiceId
    }
  }

  toJSON(): PaasOfferJson {
    return {
      id: this.id,
      idDisplay: this.idDisplay,
      orderId: this.orderId,
      operationalId: this.operationalId,
      status: this.status,
      amount: this.amount,
      effectiveDate: this.effectiveDate,
      endDate: this.endDate,
      annualizedRateBps: this.annualizedRate.value,
      pricingFunderId: this.pricingFunderId,
      pricedToInvoiceId: this.pricedToInvoiceId,
      orderIdDisplay: this.orderIdDisplay,
      traderId: this.traderId,
      traderName: this.traderName,
      traderOrganizationId: this.traderOrganizationId,
      customerId: this.customerId,
      customerName: this.customerName,
      customerOrganizationId: this.customerOrganizationId,
      pricedToInvoiceIdDisplay: this.pricedToInvoiceIdDisplay,
      fundingSpvLabel: this.fundingSpvLabel,
      feeId: this.feeId,
      fee: this.fee,
      spvFee: this.spvFee,
      fundedEffectiveDate: this.fundedEffectiveDate,
      completedEffectiveDate: this.completedEffectiveDate
    }
  }
}
